
import Footer from "./Footer"
import Header from "./Header"
import Body from "./Body"
import Sidebar from "./Sidebar"
import SidebarMenu from "./SidebarMenu.js"

export default function Layout(props = {}) {

  return (
    <div>
      <Header
        appName={<div style={{
          height: '46px',
          padding: '5px'
          }}>
            <span className="logo-lg">Nutrition&nbsp;Calculator</span>
          </div>}
        />
        <Sidebar menu={SidebarMenu} />
        <Body {...props} />
      <Footer version = "1.0.0" />
    </div>
  )
}